import { showToast } from "./utility";
import { ILoginParams, INewAddress } from "../types";
import {
  INewClinicalHistory,
  INewPersonalHistory,
  IPatientInformation,
} from "../libs/data-access/types";

export const handleValidateLoginParams = (loginParams: ILoginParams) => {
  let isValidated = false;
  if (!loginParams.email) {
    showToast({
      type: "warning",
      message: "Please provide username",
    });
    return isValidated;
  }

  if (!loginParams.password) {
    showToast({
      type: "warning",
      message: "Please provide password",
    });
    return isValidated;
  }

  isValidated = true;
  return isValidated;
};

export const handleValidNewAddress = (address: INewAddress) => {
  let isValidated = false;
  if (!address.name) {
    showToast({
      type: "warning",
      message: "Please provide name",
    });
    return isValidated;
  }
  if (!address.contact_number) {
    showToast({
      type: "warning",
      message: "Please provide phone no.",
    });
    return isValidated;
  }
  if (!address.postal_code) {
    showToast({
      type: "warning",
      message: "Please provide postal code",
    });
    return isValidated;
  }
  if (!address.address_line_1) {
    showToast({
      type: "warning",
      title: "Please Provide Street Address (line 1)",
      message: "Please provide postal code adn search address",
    });
    return isValidated;
  }
  isValidated = true;
  return isValidated;
};
export const handleValidPatientInformation = (
  patientInfo: IPatientInformation
) => {
  let isValidated = false;
  if (!patientInfo.first_name.trim()) {
    showToast({
      type: "warning",
      message: "Please provide patient first name",
    });
    return isValidated;
  }
  if (!patientInfo.age) {
    showToast({
      type: "warning",
      message: "Please provide patient dob",
    });
    return isValidated;
  }
  if (!patientInfo.address.trim()) {
    showToast({
      type: "warning",
      message: "Please provide patient address",
    });
    return isValidated;
  }
  if (!patientInfo.primary_contact_no) {
    showToast({
      type: "warning",
      message: "Please provide patient phone no.",
    });
    return isValidated;
  }
  if (
    patientInfo.primary_contact_no < 1000000000 ||
    patientInfo.primary_contact_no > 9999999999
  ) {
    showToast({
      type: "warning",
      message: "Please provide correct 10 digits phone no.",
    });
    return isValidated;
  }
  if (!patientInfo.hospital_no) {
    showToast({
      type: "warning",
      message: "Please provide hospital no.",
    });
    return isValidated;
  }
  isValidated = true;
  return isValidated;
};
export const handleValidatePersonalHistory = (
  personalHistory: INewPersonalHistory
) => {
  let isValidated = false;
  if (!personalHistory.state_of_residence) {
    showToast({
      type: "warning",
      message: "Please provide residence state ! ",
    });
    return isValidated;
  }
  if (!personalHistory.birth_state) {
    showToast({
      type: "warning",
      message: "Please provide birth state ! ",
    });
    return isValidated;
  }
  if (!personalHistory.kuppuswamy_scale_occupation_of_the_head) {
    showToast({
      type: "warning",
      message: "Please provide kuppuswamy scale ( occupation of the head) ",
    });
    return isValidated;
  }
  if (!personalHistory.kuppuswamy_scale_education_of_the_head) {
    showToast({
      type: "warning",
      message: "Please provide kuppuswamy scale ( education of the head)",
    });
    return isValidated;
  }
  if (!personalHistory.kuppuswamy_scale_updated_monthly_family_income) {
    showToast({
      type: "warning",
      message:
        "Please provide kuppuswamy scale ( updated monthly family income)",
    });
    return isValidated;
  }
  isValidated = true;
  return isValidated;
};

export const handleValidClinicalHistory = (
  personalHistory: INewClinicalHistory
) => {
  let isValidated = false;
  if (personalHistory.typhoid) {
    if (!personalHistory.typhoid[0]?.years_back_count) {
      showToast({
        type: "warning",
        message: "Please provide typhoid duration ! ",
      });
      return isValidated;
    }
  }
  isValidated = true;
  return isValidated;
};

export const acceptOnlyNumbers = (value: string) => {
  return value.replace(/[^0-9]/g, "");
};

export const acceptOnlyNumbersWithDecimal = (value: string) => {
  let cleaned = value.replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");
  if (parts.length > 2) {
    cleaned = parts[0] + "." + parts.slice(1).join("");
  }

  return cleaned;
};